export default function Typography() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '.Mui-disabled': {
          cursor: 'not-allowed !important',
        },
      },
    },
  };
}
